import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import './QnaStyle.css';
import { Container, Col, Row, Card, Accordion, Table } from 'react-bootstrap'
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel'
import ClipLoader from "react-spinners/ClipLoader";
import Modal from 'react-modal'
import axios from 'axios';
import moment from 'moment';
import parse from 'html-react-parser';

import firebase from 'lib/firebase';
import api from 'lib/api';
import global from 'lib/global';
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';
import HeaderWrite from '../Components/HeaderWrite';

import * as UserActions from 'store/modules/UserModule';


class QnaReadScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInfo: {},
            qnaData: this.props.history.location.state.data,
        }
    }

    componentDidMount() {
        const self = this;

        firebase.auth().onAuthStateChanged(async function (user) {
            let userData = await self.props.userActions.getUserInfo();
            if (userData.data.result) {
                self.setState({ userInfo: userData.data.data });
            }
        });
    }

    onClickBack = () => {
        console.log("목록으로 돌아가기")
        this.props.history.goBack();
    }

    onClickReply = () => {
        if (this.state.userInfo.idx > 0 && this.state.userInfo.email.match("@boomco.org").length > 0) {
            this.props.history.push({ pathname: `/qna/new`, state: { data: this.state.qnaData, userIdx: this.state.userInfo.idx, postType: 1 } })
        } else {
            alert("로그인해주세요")
        }
    }

    onClickEdit = () => {
        console.log("수정하기")
        let data = this.state.qnaData;
        let idx = this.state.qnaData.idx;
        let userIdx = this.state.qnaData.user_idx;

        if (this.state.userInfo.idx == userIdx) {
            this.props.history.push({ pathname: `/qna/${idx}/edit`, state: { data: data } });
        } else {
            alert("해당 글 수정 불가 아이디")
        }
    }

    render() {
        console.log("read", this.state.qnaData)
        let LayoutRead = "글을 찾을 수 없습니다."
        if (this.state.qnaData != null) {
            let convertBody = parse(this.state.qnaData.contents);
            LayoutRead = (
                <div>
                    <div>title : {this.state.qnaData.title}</div>
                    <div>contents : {convertBody}</div>
                </div>
            )
        }

        let btnEdit;
        if (this.state.userInfo.idx == this.state.qnaData.user_idx) {
            btnEdit = <div onClick={this.onClickEdit} style={{ backgroundColor: 'orange' }}>Edit</div>
        }

        let btnReply;
        if (this.state.userInfo.idx > 0 && this.state.userInfo.email.match("@boomco.org").length > 0) {
            btnReply = <div onClick={this.onClickReply} style={{ backgroundColor: 'orange' }}>Reply</div>
        }
        if (this.state.userInfo.idx > 0 && this.state.userInfo.idx == this.state.qnaData.group_original_user) {
            // console.log("group's original user")
            btnReply = <div onClick={this.onClickReply} style={{ backgroundColor: 'orange' }}>Reply</div>
        }


        return (
            <div id="qna_read">
                <div>글 읽기 페이지</div>
                {LayoutRead}

                <Container>
                    <Row>
                        <Col><div onClick={this.onClickBack} style={{ backgroundColor: 'orange' }}>Back</div></Col>
                        <Col></Col>
                        <Col>{btnReply}</Col>
                        <Col></Col>
                        <Col>{btnEdit}</Col>
                        <Col></Col>
                        <Col>
                            <Link to={'/qna'}>
                                <div style={{ backgroundColor: 'orange' }}>List</div>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}




let mapStateToProps = (state) => ({
    // userInfo: JSON.parse(JSON.stringify(state.UserModule.get('userInfo'))),
});

let mapDispatchToProps = (dispatch) => ({
    userActions: bindActionCreators(UserActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(QnaReadScreen);